import styled from 'styled-components'

export const FeaturedArticleContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;

  overflow: hidden;
  border-radius: 16px;
  z-index: 1;
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0px 16px 16px rgba(38, 38, 54, 0.26),
      0px 24px 32px rgba(36, 36, 49, 0.253);
  }

  .description {
    color: ${({ theme }) => theme.colors.white};
    text-align: left;

    white-space: pre-wrap;
    font-weight: ${({ theme }) => theme.fontWeights.light};

    line-height: ${({ theme }) => theme.lineHeight.b3};
    font-size: ${({ theme }) => theme.fontSizes.b3};
  }

  .linear-gradient {
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, #202328 600px, transparent);
    position: absolute;
    z-index: -1;
    border-radius: 0 16px 16px 0;

    @media (max-width: 791px) {
      background: linear-gradient(to top, #202328 400px, transparent);
      border-radius: 0 0 16px 16px;
    }
    @media (max-width: 480px) {
      background: linear-gradient(to top, #202328 550px, transparent);
    }
  }

  .article {
    width: 100%;
    max-width: 549px;
    display: flex;
    flex-direction: column;
    gap: 30px;
    align-items: flex-start;
    margin: 32px 32px 52px 0;

    .tags {
      display: flex;
      width: 100%;
      flex-wrap: wrap;
      gap: 10px;

      .tag {
        border: 1px solid white;
        padding: 8px 16px;
        border-radius: 40px;
      }
    }
  }

  .image-container {
    display: flex;
    height: 100%;
  }

  @media (max-width: 791px) {
    align-items: flex-end;
    height: 931px;
    .article {
      margin: 0 32px 32px 32px;
    }
  }
  @media (max-width: 500px) {
    max-width: 380px;
    flex-direction: column-reverse;
    height: auto;
    .article {
      margin: 0;
      max-width: 100%;
      gap: 20px;
      padding: 16px;
      background-color: #202328;
      .title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        max-width: 100%;
        &:hover {
          .tooltip {
            opacity: 1;
          }
        }
      }
    }
    .image-container {
      height: 136px;
      width: 100%;

      img {
        position: relative !important;
      }
    }
    .linear-gradient {
      display: none;
    }
  }

  @media (max-width: 380px) {
    max-width: 290px;
  }
`
